import React, { Component } from "react";
import { withRouter } from "react-router";
import styles from "../../../assets/css/modules/claims/claim-details-action-buttons.css";
import Button from "../../shared/buttons/Button";
import { Paths, Urls } from "../../../constants/UrlConstants";
import { updateMakeAClaimProperties } from "../../../actions/makeAClaim/MakeAClaimActions";
import { connect } from "react-redux";
import { CLAIM_BACK, AUTHORISE_TREATMENT } from "../../makeAClaim/Constants";
import { EPDomain_ROOT } from "../../../constants/EP-config";
import EPQueryParams from "../../../constants/EPQueryParams";

export const mapStateToProps = (state) => {
  return {
    featureFlagEP : state.unreadMessagesReducer.featureFlagEP,
    IsInternalView: state.policyReducer && state.policyReducer.policyDetails && state.policyReducer.policyDetails.IsInternalView,
  };
};

export class ClaimDetailsActionButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authoriseUrl:Urls.EngagementPortal[EPDomain_ROOT].preauth,
      uploadInvoice:Urls.EngagementPortal[EPDomain_ROOT].uploadDoc
    };
    this.authoriseTreatmentOnClickHandler = this.authoriseTreatmentOnClickHandler.bind(
      this
    );
    this.uploadInvoiceOnClickHandler = this.uploadInvoiceOnClickHandler.bind(
      this
    );
  }
  handleCallbackAuthorise = (childData) => {
    this.setState({ authoriseUrl: childData });
  };

  handleCallbackUploadInvoice = (childData) => {
    this.setState({ uploadInvoice: childData });
  };
  authoriseTreatmentOnClickHandler() {
    if(this.props.featureFlagEP === false || this.props.featureFlagEP === undefined){
    this.props.history.push(Paths.MakeAClaim);
    }else {
      window.open(this.state.authoriseUrl, "_blank", "noopener");
    }
    this.props.updateMakeAClaimProperties({
      claimType: AUTHORISE_TREATMENT,
      isNewClaim: false
    });
  }

  uploadInvoiceOnClickHandler() {
    if(this.props.featureFlagEP === false || this.props.featureFlagEP === undefined){
    this.props.history.push(Paths.MakeAClaim);
  }else {
    window.open(this.state.uploadInvoice, "_blank", "noopener");
  }
    this.props.updateMakeAClaimProperties({
      claimType: CLAIM_BACK
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="mt-5">
          <p className={styles.buttonDesc + " mb-2"}>
            {this.props.authoriseTreatmentDesc}
          </p>
          <Button
            id={this.props.authoriseTreatmentButtonId}
            onClick={this.authoriseTreatmentOnClickHandler}
            label={this.props.authoriseTreatmentButtonLabel}
            IsInternalView={this.props.IsInternalView}
            disabled={this.props.IsInternalView}
          />
        </div>
        <EPQueryParams url={this.state.authoriseUrl} updatedURL={this.handleCallbackAuthorise}/>
        <EPQueryParams url={this.state.uploadInvoice} updatedURL={this.handleCallbackUploadInvoice}/>
        <div className="mt-4">
          <p className={styles.buttonDesc + " mb-2"}>
            {this.props.uploadInvoiceDesc}
          </p>
          <Button
            id={this.props.uploadInvoiceButtonId}
            onClick={this.uploadInvoiceOnClickHandler}
            label={this.props.uploadInvoiceButtonLabel}
            buttonType={this.props.uploadInvoiceButtonType}
            IsInternalView={this.props.IsInternalView}
            disabled={this.props.IsInternalView}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(
  connect(mapStateToProps, { updateMakeAClaimProperties })(ClaimDetailsActionButtons)
);
